
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Google Analytics setup
const addGoogleAnalytics = () => {
  // Create script elements for Google Analytics
  const gtagScript = document.createElement('script');
  gtagScript.async = true;
  gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-YD7PXLJ142'; 
  document.head.appendChild(gtagScript);

  // Initialize gtag
  window.dataLayer = window.dataLayer || [];
  function gtag(...args: any[]) {
    window.dataLayer.push(arguments);
  }
  gtag('js', new Date());
  gtag('config', 'G-YD7PXLJ142', {
    'linker': {
      'domains': ['flowcare.health', 'www.flowcare.health']
    }
  });

  // Make gtag available globally
  window.gtag = gtag;
};

// Add Google Analytics to the page
addGoogleAnalytics();

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Failed to find the root element");

createRoot(rootElement).render(<App />);

